import { EventBus } from '../event-bus.js';
import __vue_component__ from './Node.vue.js';

//
var script = {
  name: 'Tree',
  components: {
    Node: __vue_component__
  },
  props: {
    nodes: {
      type: Array,
      default: () => []
    },
    value: {
      type: [Object],
      default: undefined
    },
    expandLevel: {
      type: Number,
      default: 2
    },
    currentSuggestionId: {
      type: [Number, String],
      default: undefined
    },
    search: {
      type: String,
      default: ''
    }
  },

  data() {
    return {
      hovered: undefined,
      expanded: [],
      initialExpandedState: [],
      onToggleExpandListener: undefined
    };
  },

  computed: {
    selected() {
      return this.value ? this.value.id : undefined;
    },

    childNodes() {
      return this.getChildNodes(this.nodes);
    }

  },
  watch: {
    currentSuggestionId: {
      handler(index) {
        this.hovered = index;
      },

      immediate: true
    },
    expanded: {
      handler(expanded) {
        if (this.search.length === 0) {
          this.initialExpandedState = expanded;
        }
      },

      immediate: true
    },

    search(search) {
      if (search.length === 0) {
        this.expanded = this.initialExpandedState;
      }
    }

  },

  mounted() {
    this.onToggleExpandListener = () => this.onToggleExpand(this.currentSuggestionId);

    EventBus.$on('remote-expand', this.onToggleExpandListener);
  },

  destroyed() {
    EventBus.$off('remote-expand', this.onToggleExpandListener);
  },

  methods: {
    onSelect(id, ancestors = []) {
      this.$emit('input', this.childNodes.find(node => node.id === id), ancestors);
    },

    highlight(id) {
      this.hovered = id;
    },

    onMouseOut() {
      this.hovered = undefined;
    },

    onToggleExpand(toggled) {
      this.expanded = this.expanded.some(id => toggled === id) ? this.expanded.filter(id => toggled !== id) : [...this.expanded, toggled];
    },

    getChildNodes(children = []) {
      return children.reduce((nodes, node) => {
        if (node.children) {
          return [...nodes, node, ...this.getChildNodes(node.children)];
        }

        return [...nodes, node];
      }, []);
    },

    onExpand(ids) {
      this.$nextTick(() => {
        this.expanded = [...new Set([...this.expanded, ...ids])];
      });
    }

  }
};

export default script;



// WEBPACK FOOTER //
// ./node_modules/@spartez/vue-atlaskit/dist/components/Tree/Tree.vue_rollup-plugin-vue=script.js